import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

@Injectable()
export class AuthorizeInfoService {
  constructor (private http: Http) {
  }

  fileUpload (data: any) {
    return this.http.postForm('/authorization/upload', data)
  }
}
